import { initMatches } from '../lib/utils/match.utils';
import { initTeams, getTeams } from '../lib/utils/team.utils';
import ARG from '../assets/flags/ARG.svg?raw';
import AUS from '../assets/flags/AUS.svg?url';
import BEL from '../assets/flags/BEL.svg?url';
import BRA from '../assets/flags/BRA.svg?url';
import CAN from '../assets/flags/CAN.svg?url';
import CMR from '../assets/flags/CMR.svg?url';
import CRC from '../assets/flags/CRC.svg?url';
import CRO from '../assets/flags/CRO.svg?url';
import DEN from '../assets/flags/DEN.svg?url';
import ECU from '../assets/flags/ECU.svg?url';
import ENG from '../assets/flags/ENG.svg?url';
import ESP from '../assets/flags/ESP.svg?url';
import FRA from '../assets/flags/FRA.svg?url';
import GER from '../assets/flags/GER.svg?url';
import GHA from '../assets/flags/GHA.svg?url';
import IRN from '../assets/flags/IRN.svg?url';
import JPN from '../assets/flags/JPN.svg?url';
import KOR from '../assets/flags/KOR.svg?url';
import KSA from '../assets/flags/KSA.svg?url';
import MEX from '../assets/flags/MEX.svg?url';
import MOR from '../assets/flags/MOR.svg?url';
import NED from '../assets/flags/NED.svg?url';
import POL from '../assets/flags/POL.svg?url';
import POR from '../assets/flags/POR.svg?url';
import QAT from '../assets/flags/QAT.svg?url';
import SEN from '../assets/flags/SEN.svg?url';
import SRB from '../assets/flags/SRB.svg?url';
import SUI from '../assets/flags/SUI.svg?url';
import TUN from '../assets/flags/TUN.svg?url';
import URU from '../assets/flags/URU.svg?url';
import USA from '../assets/flags/USA.svg?url';
import WAL from '../assets/flags/WAL.svg?url';

console.log(ARG)

export let flags = {
  ARG,
  AUS,
  BEL,
  BRA,
  CAN,
  CMR,
  CRC,
  CRO,
  DEN,
  ECU,
  ENG,
  ESP,
  FRA,
  GER,
  GHA,
  IRN,
  JPN,
  KOR,
  KSA,
  MEX,
  MOR,
  NED,
  POL,
  POR,
  QAT,
  SEN,
  SRB,
  SUI,
  TUN,
  URU,
  USA,
  WAL,
};

let totalImages = 0;

class Loader {
  loadTeams() {
    return fetch('/data/teams.json')
      .then((response) => response.json())
      .then((data) => {
        initTeams(data);
      });
  }
  loadMatches() {
    return fetch('/data/matches.json')
      .then((response) => response.json())
      .then((data) => {
        return initMatches(data);
      });
  }

  loadFlags() {
    function loaded(resolve) {
      totalImages++;
      if (totalImages >= 32) {
        resolve();
      }
    }

    return new Promise((resolve) => {
      for (const [key, value] of Object.entries(flags)) {
        fetch(value).then(() => {
          loaded(resolve);
        });
      }
    });
  }

  load() {
    return this.loadTeams()
      .then(() => {
        return this.loadMatches();
      })
      .then(() => {
        return this.loadFlags();
      });
  }
}

export default new Loader();
